
<template>
  <fs1-div class="CtableFiles">
    <v-layout wrap>
      <v-flex md4>
        <slot></slot>
      </v-flex>
      <v-flex md8 v-if="!disabled" class="btnContainer">
        <button class="custom-file-upload2" @click="add" :class="dark_t?'dark':''">
          <v-icon small>add</v-icon>
          <fs1-span>Agregar documento</fs1-span>
        </button>
        <!-- <fs1-tooltip text="Ingresa Pautas de Mantenimiento correspondientes al Activo Crítico."/> -->
      </v-flex>
    </v-layout>
    <table class="tableFiles" :class="dark_t?'dark':''">
      <thead>
        <tr>
          <th v-for="(header, i) in headers" :key="i" :class="header.class || ''">
            {{header.text}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row,i) in rows" :key="i">
          <td>{{row.name}}</td>
          <td>{{datetimeConversor2(row.updated)}}</td>
          <td>
            <fs1-span v-if="hasAuthFile(row)">
              <v-progress-circular v-if="is_auth_file_opening(row)" indeterminate color="primary" size="20" width="2"/>
              <v-icon v-else class="pointer_hover" @click="open_auth_file(row)">insert_drive_file</v-icon>
            </fs1-span>
          </td>
          <td v-if="!disabled">
            <v-icon @click="ask_remove(row)">delete</v-icon>
            <v-icon @click="edit(row)">edit</v-icon>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr v-if="!rows.length">
          <td :colspan="headers.length">
            <b>Sin documentos</b>
          </td>
        </tr>
      </tfoot>
    </table>

    <v-dialog v-model="dialog_write" width="500" v-if="selectedItem">
			<v-card class="pa-40">
				<h3 class="textAlignCenter">Documento</h3>
        <br>
        <table style="width: 100%;">
          <tr>
            <td class="pa-2"><b>Nombre</b></td>
            <td class="pa-2">
              <in-text v-model="selectedItem.name" placeholder=" ingresar texto" :condensed="true"/>
            </td>
            <td class="pa-2">
              <v-icon @click="selectedItem.name = null">clear</v-icon>  
            </td>
          </tr>
          <tr>
            <td class="pa-2"><b>Archivo</b></td>
            <td class="pa-2">
              <fs1-span v-if="hasAuthFile(selectedItem) && typeof selectedItem.document === 'string'">
                <v-progress-circular v-if="is_auth_file_opening(selectedItem)" indeterminate color="primary" size="20" width="2"/>
                <v-icon v-else class="pointer_hover" @click="open_auth_file(selectedItem)">insert_drive_file</v-icon>
              </fs1-span>
              <label v-else :for="`file-upload-${id}`" class="custom-file-upload2" style="display: inline-block" :class="dark_t?'dark':''">
                <fs1-span>{{['Cargar', 'Cargando', 'Cargado'][selectedItem.status]}} </fs1-span>
                <v-icon small v-if="selectedItem.status === 0">attach_file</v-icon>
                <v-icon small v-if="selectedItem.status === 1">hourglass_empty</v-icon>
                <v-icon small v-if="selectedItem.status === 2">check</v-icon>
                <input :id="`file-upload-${id}`" class="btn" type="file" @change="selectFile(selectedItem, $event.target.files)">
              </label>
            </td>
            <td class="pa-2"><v-icon @click="selectedItem.status=0;selectedItem.document = null">clear</v-icon></td>
          </tr>
        </table>

        <br>
				<div class="mt-40 textAlignCenter">
					<v-btn color="secondary" @click="cancel_write" :disabled="saving">
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary" @click="save" :disabled="saving">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

    <v-dialog v-model="dialog_remove" width="400" v-if="selectedItem">
			<v-card class="pa-40 textAlignCenter">
				<h3>Eliminar documento</h3>
        <b>"{{selectedItem.name}}"</b>
				<br>

				<div class="mt-40">
					<v-btn color="secondary" @click="cancel_remove">
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary" @click="remove">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

  </fs1-div>
</template>

<script>
import {
  add_action_documents,
  delete_action_document,
  edit_action_document,
} from '@/requests/ac';

import {v4 as uuid} from 'uuid';
import open_auth_file from '@/mixins/open_auth_file';

export default {
  mixins: [open_auth_file],
  props: ['rows','disabled','merge_item'],
  data() {
    return {
      id: uuid(),
      name: 'action_document',
      dialog_remove: false,
      dialog_write: false,
      selectedItem: null,
      saving:false,
    };
  },
  computed:{
    headers() {
      const hs = [
        { text: 'Nombre del documento'},
        { text: 'Fecha de Carga', class: 'width150px'},
        { text: 'Archivo', class: 'width150px'},
      ]
      if (!this.disabled) hs.push({ text: '', class: 'width100px'});
      return hs;
    },
    add_m(){ return add_action_documents },
    edit_m() {return edit_action_document },
    remove_m() {return delete_action_document },
  },
  methods: {
    datetimeConversor2(stringDatetime) {
      if (stringDatetime === null) return 'No definida'
      const datetime = new Date(Date.parse(stringDatetime))
      return `${datetime.getUTCDate().toString().padStart(2, '0')}-${(datetime.getUTCMonth() + 1).toString().padStart(2, '0')}-${datetime.getUTCFullYear()}, ${datetime.getHours().toString().padStart(2, '0')}:${datetime.getMinutes().toString().padStart(2, '0')}`
    },
    ask_remove(item) {
      this.selectedItem = item;
      if (item.document) this.dialog_remove = true;
      else this.remove();
    },
    async remove() {
      const item = this.selectedItem;
      if(!await this.assignAccess()) return this.getError('no se pudo obtener acceso');
      this.dialog_remove = false;
      this.remove_m(item.id)
        .then(r => {
          this.dev_log({r});
          this.rows.splice(this.rows.indexOf(item), 1);
        });
    },
    edit(item){
      this.selectedItem = item;
      this.dialog_write = true;
    },
    add() {
      this.selectedItem = {
        name: '',
        document: null,
        status: 0,
        file_name: null,
      };
      this.dialog_write = true;
    },
    cancel_write(){
      this.selectedItem = null;
      this.dialog_write = false;
    },
    cancel_remove(){
      this.selectedItem = null;
      this.dialog_remove = false;
    },
    async save(){
      const sv = this.selectedItem;
      Object.assign(sv,{...this.merge_item});
      ['remediation','action', 'closing_validation']
        .forEach(k=> {
          if(!sv[k]) delete sv[k];
        })
      this.setProgress({show:true, message:'Guardando...'});
      if(!await this.assignAccess()) return this.getError('no se pudo obtener acceso');
      this.saving = true;
this.dev_log(sv.id,this.selectedItem.id);
      (sv.id?this.edit_m:this.add_m)(sv)
        .then(r =>{
          this.saving = false;
          this.dev_log({r});
          this.setProgress({show:false});
          this.dialog_write = false;
          sv.id
            ? Object.assign(sv,r)
            : this.rows.push(Object.assign(sv,r));
        })
        .catch(e=>{this.saving = false;this.getError(e)});
    },
    selectFile(item, files) { // files no es un array por lo que sus proto funciones no aplican
      item./* file */document = files[0]
      item.status = 1;
      const reader = new FileReader();
      reader.onload = e => item.status = 2;
      reader.readAsDataURL(files[0]);
		},
  }, // methods
};
</script>

<style scoped>
  .CtableFiles{
    margin-bottom: 20px;
  }
  .btnContainer{
    text-align: right;
    margin-bottom: 10px; 
  }
  .tableFiles tr>th:nth-of-type(1) ,
  .tableFiles tr>td:nth-of-type(1) {
    text-align: left;
  }
  .tableFiles tr>th:nth-of-type(2) ,
  .tableFiles tr>td:nth-of-type(2) {
    text-align: center;
  }
  .tableFiles tr>th:nth-of-type(3) ,
  .tableFiles tr>td:nth-of-type(3) {
    text-align: center;
  }
</style>
